<template>
  <el-dialog :title="dialogType==0?'添加栏目':'编辑栏目'" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <el-form ref="form" :model="form" label-width="160px">
        <el-form-item label="栏目名称">
          <el-input v-model="form.name" placeholder="请输入栏目名称"></el-input>
        </el-form-item>
        <el-form-item label="支持投放的动态类型">
          <el-select v-model="value" placeholder="请选择" size="large">
            <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="savePrograma">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import api from '@/api.js'
  export default {
    name: "addColumnDialog",
    props: ["visible", "dialogType", "dialogContent"],
    watch: {
      visible() {
        this.dialogVisible = this.visible;
      }
    },
    data() {
      return {
        dialogVisible: this.visible,
        form: {
          name: ''
        },
        options: [{
          value: 0,
          label: '支持企业动态和个人动态'
        },{
          value: 1,
          label: '仅支持企业动态'
        },{
          value: 2,
          label: '仅支持个人动态'
        }],
        value: 0
      };
    },
    created() {
      if (this.dialogType === 1) {
        this.form.name = this.dialogContent.name
        this.value = this.dialogContent.type
      }
    },
    methods: {
      savePrograma() {
        if (this.form.name === '') {
          this.$message({
            message: '请编辑需要添加的类目名称',
            type: 'warning'
          });
          return
        }
        let url_ =  api.programa_add;
        let data_ = {}
        data_.name = this.form.name
        data_.type = this.value
        if (this.dialogType === 1) {
          url_ = api.programa_edit;
          data_.pro_id = this.dialogContent.id;
        }
        this.axios
          .post(url_, data_)
          .then(response => {
            if (response.data.code == 0) {
              let title = '添加栏目成功!'
              if(this.dialogType === 1){
                title = '编辑栏目成功!'
              }
              this.$message({
                message: title
              });
              this.dialogVisible = false
              this.form.name = ''
              this.$emit('initFn');
            } else {
            }
          })
          .catch(response => {
          });
      }
    }
  };
</script>

